import { ContentWrapper } from "../../components/Wrappers/Wrappers"
import { DetailText, Title } from "../../components/units/Text"
import { useState, useEffect } from "react"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { useValidatePermission } from "../../roles/roles"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { AxiosUserResponseProps, Params } from "../../components/Rest/RestUsers"
import { AxiosFetchUserList } from "../../components/Rest/RestUsers"
import { SearchField } from "../../components/SearchFields/SearchFields"
import { UserTable } from "../../components/Tables/UserTable"
import { RestApiState } from "../../components/Rest/Organization"
import Alert from "../../components/units/Alerts"
import { Text } from "../../components/units/Text"


export const defaultParams = (): Params => {
    return {
        limit: 10,
        offset: 0,
        currentPage: 1,
        timeout: undefined,
        is_manufacture_date: undefined
    }
}


export const Users = () => {
    const { user } = useSignedInContext()
    useValidatePermission({ role : user.role, resource: 'Users', action: 'view' })

    const [list, setList] = useState<AxiosUserResponseProps | undefined>(undefined)
    const [params, setParams] = useState<Params>(defaultParams())


    useEffect(() => {
        AxiosFetchUserList(params, setList)
    }, [params.currentPage, params.ordering, params.is_manufacture_date])

    const useDeleteCallBack = (value: RestApiState) => {
        if (value === RestApiState.Success) {
            AxiosFetchUserList(params, setList)
        }
    }

    useEffect(() => {
        const dropTimeout = ():void => {
            clearTimeout(params.timeout)
            setParams((prev) => ({
                ...prev, timeout : undefined
            }))

        }
        if (params.search === undefined) {
            return
        }
        if (params.timeout) {
            dropTimeout()
        } 
        const timeout = setTimeout(() => {
            AxiosFetchUserList(params, setList)
            dropTimeout()
        }, 750) 
        setParams((prev) => ({
            ...prev, timeout : timeout
        }))
    }, [params.search])

    return (
        <ContentWrapper>
            <Title>Список пользователей</Title>
            <br />
            <BoxWrapper p="p0">
                <FlexWrapper justifyContent="space-between" alignItems="center">
                    <DetailText href="/react/users/create"
                        color="light"
                        bg="bg-secondary"
                        className="p1 flex align-center justify-center"
                        r="r15"
                        style={{height:'36px'}}
                    >Пригласить пользователя</DetailText>
                    <SearchField 
                        timeout={params.timeout} 
                        setSearch={(search:string):void => {
                            setParams((prev) => ({
                                ...prev, search : search
                            }))
                        }}
                        placeholder="ФИО, телефон, почта"
                        />
                </FlexWrapper>
            </BoxWrapper>
            <br />

            <UserTable 
                data={list} 
                currentPage={params.currentPage} 
                itemsPerPage={params.limit}
                params={params}
                setter={(value: number) => {
                    setParams((prev) => ({
                        ...prev, currentPage: value
                    }))
                }}
                orderSetter={(value: string): void => {
                    setParams((prev) => ({
                        ...prev, ordering : value
                    }))}}
                deleteHook = {useDeleteCallBack}
                />
        </ContentWrapper>
        
    )
}